import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardScoreGoalProgressColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 90 88" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_306_13917"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="3"
        width="85"
        height="85"
      >
        <path
          d="M37.7959 9.37988C43.207 3.96898 51.9805 3.96897 57.3916 9.37988L58.3047 10.2939C60.2738 12.2631 62.9447 13.3691 65.7295 13.3691H65.9619C73.6144 13.3691 79.8184 19.5731 79.8184 27.2256V27.458C79.8184 30.2428 80.9244 32.9137 82.8936 34.8828L83.8066 35.7959C89.2178 41.207 89.2178 49.9805 83.8066 55.3916L82.8936 56.3047C80.9244 58.2738 79.8184 60.9447 79.8184 63.7295V63.9619C79.8184 71.6144 73.6144 77.8184 65.9619 77.8184H65.7295C62.9447 77.8184 60.2738 78.9244 58.3047 80.8936L57.3916 81.8066C51.9805 87.2178 43.207 87.2178 37.7959 81.8066L36.8828 80.8936C34.9137 78.9244 32.2428 77.8184 29.458 77.8184H29.2256C21.5731 77.8184 15.3691 71.6144 15.3691 63.9619V63.7295C15.3691 60.9447 14.2631 58.2738 12.2939 56.3047L11.3799 55.3916C5.96898 49.9805 5.96898 41.207 11.3799 35.7959L12.2939 34.8828C14.2631 32.9137 15.3691 30.2428 15.3691 27.458V27.2256C15.3691 19.5731 21.5731 13.3691 29.2256 13.3691H29.458C32.2428 13.3691 34.9137 12.2631 36.8828 10.2939L37.7959 9.37988Z"
          fill="url(#paint0_linear_306_13917)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
      </mask>
      <g mask="url(#mask0_306_13917)">
        <path
          d="M37.7959 9.37988C43.207 3.96898 51.9805 3.96897 57.3916 9.37988L58.3047 10.2939C60.2738 12.2631 62.9447 13.3691 65.7295 13.3691H65.9619C73.6144 13.3691 79.8184 19.5731 79.8184 27.2256V27.458C79.8184 30.2428 80.9244 32.9137 82.8936 34.8828L83.8066 35.7959C89.2178 41.207 89.2178 49.9805 83.8066 55.3916L82.8936 56.3047C80.9244 58.2738 79.8184 60.9447 79.8184 63.7295V63.9619C79.8184 71.6144 73.6144 77.8184 65.9619 77.8184H65.7295C62.9447 77.8184 60.2738 78.9244 58.3047 80.8936L57.3916 81.8066C51.9805 87.2178 43.207 87.2178 37.7959 81.8066L36.8828 80.8936C34.9137 78.9244 32.2428 77.8184 29.458 77.8184H29.2256C21.5731 77.8184 15.3691 71.6144 15.3691 63.9619V63.7295C15.3691 60.9447 14.2631 58.2738 12.2939 56.3047L11.3799 55.3916C5.96898 49.9805 5.96898 41.207 11.3799 35.7959L12.2939 34.8828C14.2631 32.9137 15.3691 30.2428 15.3691 27.458V27.2256C15.3691 19.5731 21.5731 13.3691 29.2256 13.3691H29.458C32.2428 13.3691 34.9137 12.2631 36.8828 10.2939L37.7959 9.37988Z"
          fill="url(#paint1_linear_306_13917)"
          stroke="#9ED79D"
          strokeWidth="3.35598"
        />
        <g filter="url(#filter0_f_306_13917)">
          <path
            d="M136.941 38.9307L153.599 53.2837L58.6539 135.476L41.9957 121.123L136.941 38.9307Z"
            fill="#E8F9E1"
          />
        </g>
        <g filter="url(#filter1_f_306_13917)">
          <path
            d="M165.386 59.1728L171.941 64.8213L76.9966 147.013L70.441 141.365L165.386 59.1728Z"
            fill="#E8F9E1"
          />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.1111 24C40.3384 24 41.3333 24.9426 41.3333 26.1053V28.2105H54.6667V26.1053C54.6667 24.9426 55.6616 24 56.8889 24C58.1162 24 59.1111 24.9426 59.1111 26.1053V28.2105C64.0203 28.2105 68 31.9808 68 36.6316V55.5789C68 60.2298 64.0203 64 59.1111 64H36.8889C31.9797 64 28 60.2298 28 55.5789V36.6316C28 31.9808 31.9797 28.2105 36.8889 28.2105V26.1053C36.8889 24.9426 37.8838 24 39.1111 24ZM55.1269 40.9324C55.9948 41.7546 55.9948 43.0875 55.1269 43.9097L47.3491 51.2781C46.9324 51.6729 46.3672 51.8947 45.7778 51.8947C45.1884 51.8947 44.6232 51.6729 44.2064 51.2781L40.8731 48.1202C40.0053 47.2981 40.0053 45.9651 40.8731 45.1429C41.7409 44.3208 43.148 44.3208 44.0158 45.1429L45.7778 46.8122L51.9842 40.9324C52.8521 40.1103 54.2591 40.1103 55.1269 40.9324Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M39.1111 24C40.3384 24 41.3333 24.9426 41.3333 26.1053V28.2105H54.6667V26.1053C54.6667 24.9426 55.6616 24 56.8889 24C58.1162 24 59.1111 24.9426 59.1111 26.1053V28.2105C64.0203 28.2105 68 31.9808 68 36.6316V55.5789C68 60.2298 64.0203 64 59.1111 64H36.8889C31.9797 64 28 60.2298 28 55.5789V36.6316C28 31.9808 31.9797 28.2105 36.8889 28.2105V26.1053C36.8889 24.9426 37.8838 24 39.1111 24ZM55.1269 40.9324C55.9948 41.7546 55.9948 43.0875 55.1269 43.9097L47.3491 51.2781C46.9324 51.6729 46.3672 51.8947 45.7778 51.8947C45.1884 51.8947 44.6232 51.6729 44.2064 51.2781L40.8731 48.1202C40.0053 47.2981 40.0053 45.9651 40.8731 45.1429C41.7409 44.3208 43.148 44.3208 44.0158 45.1429L45.7778 46.8122L51.9842 40.9324C52.8521 40.1103 54.2591 40.1103 55.1269 40.9324Z"
          fill="url(#paint2_linear_306_13917)"
        />
      </g>
      <path
        d="M10.1102 1.63151C10.1102 1.26332 9.81177 0.964844 9.44358 0.964844C9.07539 0.964844 8.77691 1.26332 8.77691 1.63151C8.77691 4.40507 8.16476 6.24992 7.00226 7.41242C5.83976 8.57492 3.99491 9.18706 1.22135 9.18706C0.853164 9.18706 0.554688 9.48554 0.554688 9.85373C0.554688 10.2219 0.853164 10.5204 1.22135 10.5204C3.99491 10.5204 5.83976 11.1325 7.00226 12.295C8.16476 13.4575 8.77691 15.3024 8.77691 18.076C8.77691 18.4441 9.07539 18.7426 9.44358 18.7426C9.81177 18.7426 10.1102 18.4441 10.1102 18.076C10.1102 15.3024 10.7224 13.4575 11.8849 12.295C13.0474 11.1325 14.8922 10.5204 17.6658 10.5204C18.034 10.5204 18.3325 10.2219 18.3325 9.85373C18.3325 9.48554 18.034 9.18706 17.6658 9.18706C14.8922 9.18706 13.0474 8.57492 11.8849 7.41242C10.7224 6.24992 10.1102 4.40507 10.1102 1.63151Z"
        fill="#0D2B57"
      />
      <defs>
        <filter
          id="filter0_f_306_13917"
          x="33.9961"
          y="30.9297"
          width="127.603"
          height="112.547"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_306_13917" />
        </filter>
        <filter
          id="filter1_f_306_13917"
          x="62.4414"
          y="51.1719"
          width="117.5"
          height="103.842"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="4" result="effect1_foregroundBlur_306_13917" />
        </filter>
        <linearGradient
          id="paint0_linear_306_13917"
          x1="30.2266"
          y1="7"
          x2="47.5937"
          y2="84.1875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_306_13917"
          x1="30.2266"
          y1="7"
          x2="47.5937"
          y2="84.1875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#B9EBBA" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_306_13917"
          x1="34.6667"
          y1="29"
          x2="48"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#094534" />
          <stop offset="1" stopColor="#4D9863" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardScoreGoalProgressColored);
export default ForwardRef;
